import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import Styles from "./Menu.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { updateTab } from "../../redux/slices/app";

const cx = classNames.bind(Styles);

const Menu = () => {
  const location = useLocation();

  const dispatch = useDispatch();

  const { tab } = useSelector((state) => state.app);

  const navigate = useNavigate();

  const [isManualDropdownOpen, setIsManualDropdownOpen] = useState(false);
  const manualDropdownTimer = useRef(null);

  const openManualDropdown = () => {
    if (manualDropdownTimer.current) {
      clearTimeout(manualDropdownTimer.current);
    }
    setIsManualDropdownOpen(true);
  };

  const closeManualDropdown = () => {
    manualDropdownTimer.current = setTimeout(() => {
      setIsManualDropdownOpen(false);
    }, 200);
  };

  useEffect(() => {
    return () => {
      if (manualDropdownTimer.current) {
        clearTimeout(manualDropdownTimer.current);
      }
    };
  }, []);

  useEffect(() => {
    const url = window.location.pathname;
    const lastSlash = url.lastIndexOf("/");
    const newTab = url.slice(lastSlash + 1, url.length);

    if (newTab && tab !== newTab) {
      dispatch(updateTab(newTab));
    }
  }, [location, dispatch, tab]);

  const handleUpdateTab = (tab) => {
    dispatch(updateTab(tab));
    navigate(`/${tab}`);
  };

  return (
    <div className={cx("menu")}>
      <ul className={cx("list-item")}>
        <li
          className={cx("item", tab === "" ? "active" : "")}
          onClick={() => handleUpdateTab("")}
        >
          Inicio
        </li>
        <li
          className={cx("item", tab === "about-us" ? "active" : "")}
          onClick={() => handleUpdateTab("about-us")}
        >
          ¿Quiénes somos?
        </li>
        <li
          className={cx("item", tab === "legal-framework" ? "active" : "")}
          onClick={() => handleUpdateTab("legal-framework")}
        >
          Marco legal
        </li>
        <li
          className={cx(
            "item",
            "item-dropdown",
            tab === "user-manual" || tab === "infracciones-guide"
              ? "active"
              : ""
          )}
          onMouseEnter={openManualDropdown}
          onMouseLeave={closeManualDropdown}
        >
          Manual del Usuario
          <ul
            className={cx("dropdown-content", {
              open: isManualDropdownOpen,
            })}
          >
            <li
              className={cx(
                "dropdown-link",
                tab === "user-manual" ? "active" : ""
              )}
              onClick={() => handleUpdateTab("user-manual")}
            >
              Uso del Sistema
            </li>
            <li
              className={cx(
                "dropdown-link",
                tab === "infracciones-guide" ? "active" : ""
              )}
              onClick={() => handleUpdateTab("infracciones-guide")}
            >
              Guía de Infracciones
            </li>
          </ul>
        </li>
        <li
          className={cx("item", tab === "resource-center" ? "active" : "")}
          onClick={() => handleUpdateTab("resource-center")}
        >
          Centro de Recursos
        </li>
        <li
          className={cx("item", tab === "faq" ? "active" : "")}
          onClick={() => handleUpdateTab("faq")}
        >
          Preguntas Frecuentes
        </li>
      </ul>
    </div>
  );
};

export default Menu;
